import { Translations } from "appworks/services/translations/translations";
import { lowerCaseMapKeys } from "appworks/utils/collection-utils";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

export class PartnerConnectTranslations extends Translations {
    public load(json: any) {
        super.load(json);
        this.translations = PartnerConnectManager.getTranslations();
        lowerCaseMapKeys(this.translations);
    }
}
